import { combineReducers } from 'redux';

import {
  duplicateProjectFail,
  duplicateProjectRequest,
  duplicateProjectSuccess,
} from '../actions';
import { ProjectAction, SelectedProjectState } from '../types';
import { Reducer } from '../../../types';

type ReducerOf<T extends keyof SelectedProjectState> = Reducer<SelectedProjectState, ProjectAction, T>;

const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case duplicateProjectFail.type:
    case duplicateProjectRequest.type:
      return null;

    case duplicateProjectSuccess.type:
      return action.payload;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case duplicateProjectRequest.type:
      return true;

    case duplicateProjectFail.type:
    case duplicateProjectSuccess.type:
      return false;

    default:
      return state;
  }
};

const error: ReducerOf<'error'> = (state = false, action) => {
  switch (action.type) {
    case duplicateProjectFail.type:
      return true;

    case duplicateProjectRequest.type:
    case duplicateProjectSuccess.type:
      return false;

    default:
      return state;
  }
};


export default combineReducers<SelectedProjectState>({
  data,
  loading,
  error
});
